import { single as single$1, empty as empty$1, mapRequestResolvers as mapRequestResolvers$1, par, reduce as reduce$1, seq } from '../../internal/blockedRequests.esm.js';
import { requestBlockLocally } from '../../internal/core.esm.js';
import { mapInputContext as mapInputContext$1 } from '../../internal/dataSource.esm.js';

/**
 * @since 2.0.0
 */

/**
 * `RequestBlock` captures a collection of blocked requests as a data
 * structure. By doing this the library is able to preserve information about
 * which requests must be performed sequentially and which can be performed in
 * parallel, allowing for maximum possible batching and pipelining while
 * preserving ordering guarantees.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const single = single$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const mapRequestResolvers = mapRequestResolvers$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const parallel = par;

/**
 * @since 2.0.0
 * @category constructors
 */
const reduce = reduce$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const sequential = seq;

/**
 * Provides each data source with part of its required environment.
 *
 * @since 2.0.0
 * @category utils
 */
const mapInputContext = (self, f) => reduce(self, MapInputContextReducer(f));
const MapInputContextReducer = f => ({
  emptyCase: () => empty,
  parCase: (left, right) => parallel(left, right),
  seqCase: (left, right) => sequential(left, right),
  singleCase: (dataSource, blockedRequest) => single(mapInputContext$1(dataSource, f), blockedRequest)
});

/**
 * Provides each data source with a fiber ref value.
 *
 * @since 2.0.0
 * @category utils
 */
const locally = requestBlockLocally;

export { empty, locally, mapInputContext, mapRequestResolvers, parallel, reduce, sequential, single };
